// Flow（1年間の流れ）
if (document.querySelector(".swiperFlow")) {
  function getFlowOffset() {
    if (window.innerWidth <= 767) return 20;
    return Math.max(0, (window.innerWidth - 1080) / 2);
  }

  const swiperFlowEl = document.querySelector(".swiperFlow");
  swiperFlowEl.style.paddingLeft = getFlowOffset() + "px";

  function isPc() {
    return window.innerWidth >= 767;
  }

  function updateNavVisibility(swiper) {
    const display = isPc() ? "" : "none";
    if (swiper.navigation.prevEl)
      swiper.navigation.prevEl.style.display = display;
    if (swiper.navigation.nextEl)
      swiper.navigation.nextEl.style.display = display;
  }

  const swiperFlow = new Swiper(".swiperFlow", {
    slidesPerView: "auto",
    freeMode: true,
    navigation: {
      prevEl: ".swiperFlow .swiper-button-prev",
      nextEl: ".swiperFlow .swiper-button-next",
    },
    on: {
      init: function () {
        updateNavVisibility(this);
      },
      resize: function () {
        swiperFlowEl.style.paddingLeft = getFlowOffset() + "px";
        updateNavVisibility(this);
        this.update();
      },
    },
  });
}
